/** Default sizes for manual runs from the Runs tab; the nightly job runs everything. */
export const DEFAULT_COLLECT_LIMIT = 10;
export const DEFAULT_CLASSIFY_LIMIT = 100;

/** Parse an operator-typed limit; anything that is not a positive integer falls back. */
export function parseLimit(raw: string, fallback: number): number {
  const n = Number.parseInt(raw, 10);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

/** "Full run" for a full run, "10 sources" / "100 articles" for a capped one; null when uncapped legacy. */
export function describeRunLimit(
  type: "collect" | "classify",
  limit: number | null | undefined,
  full?: boolean
) {
  if (full) return "Full run";
  if (typeof limit !== "number" || !Number.isFinite(limit) || limit <= 0) return null;
  return `${limit} ${type === "collect" ? "sources" : "articles"}`;
}
